(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bts-offer-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bts-offer-card')) {
    customElements.define(
      'bts-offer-card',
      class BtsOfferCard extends HTMLElement {
        connectedCallback() {
          this.line = this.querySelector('[data-countdown]');
          const year = parseInt(this.getAttribute('data-year'), 10);
          const month = parseInt(this.getAttribute('data-month'), 10) - 1;
          const day = parseInt(this.getAttribute('data-day'), 10);
          const hour = parseInt(this.getAttribute('data-hour'), 10);
          let minute = parseInt(this.getAttribute('data-minute'), 10);
          if (isNaN(minute)) minute = 0;

          if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hour)) {
            if (this.line) this.line.style.display = 'none';
            return;
          }

          this.target = new Date(year, month, day, hour, minute);
          this.els = {
            days: this.querySelector('[data-days]'),
            hours: this.querySelector('[data-hours]'),
            minutes: this.querySelector('[data-minutes]'),
            seconds: this.querySelector('[data-seconds]'),
          };
          this.update();
          this.tick = setInterval(() => this.update(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.tick);
        }

        update() {
          const left = this.target - new Date();
          if (left <= 0) {
            clearInterval(this.tick);
            if (this.line) this.line.style.display = 'none';
            return;
          }
          const days = Math.floor(left / 86400000);
          const hours = Math.floor((left % 86400000) / 3600000);
          const minutes = Math.floor((left % 3600000) / 60000);
          const seconds = Math.floor((left % 60000) / 1000);
          if (this.els.days) this.els.days.textContent = String(days).padStart(2, '0');
          if (this.els.hours) this.els.hours.textContent = String(hours).padStart(2, '0');
          if (this.els.minutes) this.els.minutes.textContent = String(minutes).padStart(2, '0');
          if (this.els.seconds) this.els.seconds.textContent = String(seconds).padStart(2, '0');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
  var MARGIN = 8;
  var MIN_HEIGHT = 160;
  var PANEL_WIDTH = 380;

  function positionPanel(button, panel) {
    var rect = button.getBoundingClientRect();
    var vw = window.innerWidth;
    var vh = window.innerHeight;

    var left = rect.left + rect.width / 2 - PANEL_WIDTH / 2;
    left = Math.max(MARGIN, Math.min(left, vw - PANEL_WIDTH - MARGIN));

    var availableAbove = rect.top - MARGIN;
    var availableBelow = vh - rect.bottom - MARGIN;

    panel.style.width = PANEL_WIDTH + 'px';
    panel.style.left = left + 'px';

    if (availableAbove >= MIN_HEIGHT || availableAbove >= availableBelow) {
      panel.style.top = 'auto';
      panel.style.bottom = (vh - rect.top + MARGIN) + 'px';
      panel.style.maxHeight = Math.max(availableAbove, MIN_HEIGHT) + 'px';
    } else {
      panel.style.bottom = 'auto';
      panel.style.top = (rect.bottom + MARGIN) + 'px';
      panel.style.maxHeight = Math.max(availableBelow, MIN_HEIGHT) + 'px';
    }
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-toggle-disclosure]');
    if (!toggle) return;
    requestAnimationFrame(function () {
      var disclosure = toggle.closest('.language-disclosure');
      if (!disclosure) return;
      var panel = disclosure.querySelector('[data-disclosure-panel]');
      if (!panel || panel.classList.contains('hidden')) return;
      positionPanel(toggle, panel);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["opod-header-clearance"] && !Shopify.designMode) return;
  try {
    (() => {
    const SECTION_SELECTOR = '.opod-anchor-nav-section, .opod-hero';
    const HEADER_SELECTOR = '#header';
    const PROPERTY = '--opod-header-clearance';

    if (window.opodHeaderClearanceReady) return;
    window.opodHeaderClearanceReady = true;

    /*
     * Offset positions rather than client rects: once the page is scrolled the
     * header is translated and stuck to the top, so its rect no longer
     * describes where it sits at rest. Offsets ignore transforms, which makes
     * the measurement valid at any scroll position.
     */
    const documentTop = (element) => {
      let top = 0;
      let node = element;
      while (node) {
        top += node.offsetTop;
        node = node.offsetParent;
      }
      return top;
    };

    const measure = () => {
      const sections = document.querySelectorAll(SECTION_SELECTOR);
      if (!sections.length) return;

      sections.forEach((section) => {
        section.style.setProperty(PROPERTY, '0px');
      });

      const header = document.querySelector(HEADER_SELECTOR);
      if (!header) return;

      // A header that stays in the flow already reserves its own space.
      const position = window.getComputedStyle(header).position;
      if (position !== 'absolute' && position !== 'fixed') return;

      const headerBottom = documentTop(header) + header.offsetHeight;

      // In document order, so that clearing the first section moves the ones
      // after it out from under the header before they are measured.
      sections.forEach((section) => {
        const overlap = headerBottom - documentTop(section);
        if (overlap > 0) {
          section.style.setProperty(PROPERTY, `${Math.ceil(overlap)}px`);
        }
      });
    };

    /*
     * A timer rather than requestAnimationFrame: frames are throttled while the
     * tab is in the background, which leaves the section sitting under the
     * header until the visitor interacts with the page.
     */
    let timer = null;
    const schedule = () => {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        timer = null;
        measure();
      }, 50);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule, { once: true });
    } else {
      schedule();
    }

    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);
    window.addEventListener('pageshow', schedule);
    document.addEventListener('visibilitychange', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:select', schedule);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-slider-v3"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('a[data-video-cta]').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;

    const target = new URL(href, window.location.origin);
    const live = new URLSearchParams(window.location.search);

    live.forEach((value, key) => {
      if (key === 'view') {
        target.searchParams.set(key, value);
        return;
      }
      if (!target.searchParams.has(key)) target.searchParams.set(key, value);
    });

    link.setAttribute('href', target.pathname + target.search);
  });
  } catch(e) { console.error(e); }
})();

})();
